import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import isMobile from 'ismobilejs'
import escapeKey from './helpers/escape-key'
import scrollPos from './helpers/scroll-position'

const TOGGLE_CLASS = 'header-toggle_opened'
const MENU_CLASS = 'header-slide-menu_opened'
const HEADER_CLASS = 'header_opened'
const CONTAINER_CLASS = 'header-slide-container_opened'

const header = document.querySelector('.header')
const menuEl = document.querySelector('[data-header-slide-menu]')
const toggleEl = document.querySelector('[data-header-toggle]')
const container = document.querySelector('.header-slide-container')

let opened = false

function toggleMenu(newOpened) {
  if (newOpened === opened) {
    return
  }
  opened = newOpened
  if (opened) {
    disableBodyScroll(menuEl)
    setTimeout(() => container.classList.add(CONTAINER_CLASS), 700)
  } else {
    enableBodyScroll(menuEl)
    menuEl.scrollTop = 0
    setTimeout(() => container.classList.remove(CONTAINER_CLASS), 400)
  }
  if (toggleEl) {
    toggleEl.classList.toggle(TOGGLE_CLASS)
  }
  if (menuEl) {
    menuEl.classList.toggle(MENU_CLASS)
  }
  if (header) {
    header.classList.toggle(HEADER_CLASS)
  }
}

if (toggleEl) {
  toggleEl.addEventListener('click', () => {
    toggleMenu(!opened, toggleEl)
  })
}

if (isMobile().any) {
  container.classList.add('header-popup-container_mobile')
}

escapeKey(() => {
  toggleMenu(false)
})

// eslint-disable-next-line consistent-return
export function setScrollHeader() {
  if (header.classList.contains('header-scroll')) {
    return false
  }

  header.classList.add('header-scroll')
}

export function removeScrollHeader() {
  header.classList.remove('header-scroll')
}

export default toggleMenu
